import { combineReducers } from "redux";
import Configuration from "./configuration";

const IEPReducer = combineReducers({
  Configuration: Configuration
});

export default IEPReducer;